import { Link } from "react-router-dom";
import { isIOS } from "@/lib/native";

// Apple Guideline 3.1.1: seller subscriptions cannot be purchased via Stripe inside the native iOS app.
export const SUBSCRIPTION_PURCHASE_ALLOWED = !isIOS;
export const SUBSCRIPTION_UNAVAILABLE_COPY = "A subscrição de lojista não está disponível nesta aplicação.";

export function PlansLink({ testid = "plans-link", label = "Ver planos", className = "block mt-2 text-center py-2 rounded-lg bg-black text-white font-semibold" }) {
  if (!SUBSCRIPTION_PURCHASE_ALLOWED) {
    return <p data-testid={`${testid}-unavailable`} className="mt-2 text-xs text-zinc-500">{SUBSCRIPTION_UNAVAILABLE_COPY}</p>;
  }
  return <Link to="/vender/planos" data-testid={testid} className={className}>{label}</Link>;
}
